'use strict'

define ['./success.scss'], () ->
  ($scope, $stateParams, $http, $state, RentappService, RENTAPPLICATION_API_URL, Flash) ->
    $scope.application = $stateParams.application
    $scope.unpakt_link = "http://unpakt.io/rentapplication"
    $scope.lemonade_link = "https://www.lemonade.com/l/rent-application?utm_medium=partners&utm_source=rent-application&utm_campaign=new-users"
    $scope.has_identity = false

    # If user is trying to access success page directly
    # take them back to view application page of the app.
    # If the user does not have permission to view, then
    # None shall pass page will display
    unless $scope.application
      $state.go "root.dashboard.view_application", { application_id: $stateParams.application_id}

    if $scope.application
      [has_price, is_paid] = [!!Number($scope.application.price), $scope.application.is_paid]

      $scope.has_identity = !!$scope.application.reports.find((r) -> r.source_identifier == 'mvga_identity')

      if has_price and !is_paid
        $state.go "root.applications.pay", {application_id: $scope.application.id}
      if has_price and is_paid and $stateParams.paid
        Flash.create('success', "You've been charged $" +$scope.application.price, 3000)


      _vis_opt_revenue = $scope.application.price
      window._vis_opt_queue = window._vis_opt_queue || []
      window._vis_opt_queue.push(() ->
        _vis_opt_revenue_conversion(_vis_opt_revenue)
      )

      if Object.keys($scope.application.show_ads).length > 0
        $scope.show_ads = true



// WEBPACK FOOTER //
// ./components/applications/success/success.coffee